/**
 * Created by zqy on 2018/12/17 0017.
 */
//销售头衔Id获取头衔名字
function roleName(id) {
  id = Number.parseInt(id)
  let name = ""
  switch (id) {
    case 1:
      name = '普通'
      break;
    case 2:
      name = '渠道'
      break;
    case 3:
      name = '地区'
      break;
  }
  return name
}
//获取销售头衔
export function distributeRoleName(roleId) {
  if (!roleId) return ''
  let idArr = roleId.split(',')
  if (idArr) {
    let result = ""
    for (let id of idArr) {
      if (result != "") result += ","
      result += roleName(id)
    }
    return result
  }
}
//用户角色
export function redarName(type) {
  switch (type) {
    case 1:
      return "达人"
      break;
    case 0:
      return "普通"
      break;
    default:
      return '-'
      break;
  }
}

//用户打赏等级（0-无等级,1-青铜,2-白银,3-黄金,4-铂金,5-钻石）
export function userLevelName(type) {
  switch (type) {
    case 1:
      return "青铜"
      break;
    case 2:
      return "白银"
      break;
    case 3:
      return "黄金"
      break;
    case 4:
      return "铂金"
      break;
    case 5:
      return "钻石"
      break;
    default:
      return ''
      break;
  }
}



// WEBPACK FOOTER //
// ./src/filters/meitui.js